"use strict";
exports.__esModule = true;
exports.MathOperator = exports.ChangeType = void 0;
var action_1 = require("../action");
var ChangeType;
(function (ChangeType) {
    ChangeType["SPECIFIC_VALUE"] = "specific";
    ChangeType["RELATIVE_VALUE"] = "relative";
})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
var MathOperator;
(function (MathOperator) {
    MathOperator["ADDITION"] = "addition";
    MathOperator["SUBTRACTION"] = "subtraction";
})(MathOperator = exports.MathOperator || (exports.MathOperator = {}));
//# sourceMappingURL=update_entity_types.js.map